import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './features/auth/guards/ProtectedRoute';
import LoginPage from './features/auth/pages/LoginPage';
import { Universe } from './components/ui/build/Universe';
import { Toaster } from 'sonner';

import { DomainProvider } from './contexts/DomainContext';

export default function App() {
  return (
    <>
      <Toaster theme="dark" position="bottom-right" />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <DomainProvider>
                <div style={{ width: '100vw', height: '100vh', display: 'flex', flexDirection: 'column' }}>
                  <Universe />
                </div>
              </DomainProvider>
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}
